import axios from "axios";
import { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [otpVerified, setOtpVerified] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const [otpButtonDisabled, setOtpButtonDisabled] = useState(false);
    const [otpButtonText, setOtpButtonText] = useState("Verify");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        if (userData) {
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        } else if (countdown === 0 && otpSent) {
            setOtpButtonText("Resend OTP");
            setOtpButtonDisabled(false);
        }
        return () => clearTimeout(timer);
    }, [countdown, otpSent]);

    const handleSendOtp = async () => {
        setOtpButtonDisabled(true);
        setOtpButtonText("Sending...");

        try {
            const response = await axios.post(`${BASE_URL}/changePasswordOTP.php`, { email });
            if (response.data.success) {
                setOtpSent(true);
                setCountdown(60);
                setSuccessMessage("OTP sent to your email.");
            } else {
                setErrorMessage(response.data.error || "Failed to send OTP.");
                setOtpButtonDisabled(false);
                setOtpButtonText("Verify");
            }
        } catch (error) {
            setErrorMessage("Error sending OTP. Please try again.");
            setOtpButtonDisabled(false);
            setOtpButtonText("Verify");
        }
    };

    const handleVerifyOtp = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/verifyOTP.php`, { email, otp });
            if (response.data.success) {
                setOtpVerified(true);
                setOtpButtonDisabled(true);
                setOtpButtonText('Verified')
                setCountdown(0);
                setSuccessMessage("OTP verified successfully.");
                setErrorMessage("");
            } else {
                setErrorMessage("Invalid OTP. Please try again.");
                setOtpButtonDisabled(false);
                setOtpButtonText("Verify");
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            alert("Something went wrong. Please try again.");
        }
    };

    const handleChangePassword = async () => {
        if (newPassword !== confirmPassword) {
            setErrorMessage("Passwords do not match.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/changePassword.php`, {
                otp,
                email,
                newPassword
            });
            if (response.data.success) {
                setSuccessMessage("Password changed successfully. \n Redirecting...");
                setErrorMessage("");
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
                setErrorMessage("");
            } else {
                setErrorMessage(response.data.error || "Failed to change password.");
            }
        } catch (error) {
            setErrorMessage("Error changing password. Please try again.");
        }
    };

    return (
        <div className="login-bg">
            <div className="login-container">
                <div className="logo-vc-area">
                    <h1>Forgot Password</h1>
                </div>
                <div className="login-box">
                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <div className="email-verify">
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                required
                                disabled={otpVerified}
                            />
                            {!otpVerified &&
                                <button type="button"
                                    onClick={handleSendOtp}
                                    disabled={otpButtonDisabled}>
                                    {countdown > 0 ? `Resend OTP in ${countdown}s` : otpButtonText}
                                </button>
                            }
                        </div>
                    </div>
                    {otpSent && !otpVerified && (
                        <div className="input-group">
                            <label htmlFor="otp">OTP</label>
                            <div className="email-verify">
                                <input
                                    type="number"
                                    id="otp"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    placeholder="Enter OTP"
                                    required
                                />
                                <button type="button" onClick={handleVerifyOtp}>Verify OTP</button>
                            </div>
                        </div>
                    )}
                    {otpVerified && (
                        <>
                            <div className="input-group">
                                <label htmlFor="newPassword">New Password</label>
                                <div className="password-container">
                                    <div className="email-verify">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            id="newPassword"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            placeholder="Enter new password"
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="toggle-password"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </button></div>
                                </div>
                            </div>
                            <div className="input-group">
                                <label htmlFor="confirmPassword">Confirm Password</label>
                                <input
                                    type="password"
                                    id="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Confirm new password"
                                    required
                                />
                            </div>
                            <button className="login-button" type="button" onClick={handleChangePassword}>Change Password</button>
                        </>
                    )}
                    {successMessage && <p className="success-message">{successMessage}</p>}
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
